/** @format */
import React, { FunctionComponent, ReactElement } from 'react';
import GridContainer from '../../../../../components/Grid/GridContainer';
import { SimCardServiceUsageParamsItem } from '../../../../../interfaces/collections/SimCardServiceInterface';
import GridItem from '../../../../../components/Grid/GridItem';
import I18n from '../../../../../components/Translate/I18n';
import { DateHelper } from '../../../../../helpers/DateHelper';
import i18next from 'i18next';

type OplBmeUsageType = {
    params: Array<SimCardServiceUsageParamsItem>;
    displayParamName?: boolean;
};

interface DisplayParams {
    name: string;
    value: string | number | null;
    id: number;
}

interface ServiceUsageBme {
    feautreid: number;
    featurename: string;
    initialunits: number | string;
    totalUnits?: number | string;
    remainingunits: number | string;
    unitofmeasure: string;
}

export const OplBmeUsage: FunctionComponent<OplBmeUsageType> = ({ params, displayParamName }): ReactElement => {
    const displayParams: Array<DisplayParams | null> = [];
    let serviceUsage: DisplayParams | null = null;
    let status: DisplayParams | null = null;
    let datesubscriptionfeeexpiry: DisplayParams | null = null;

    const getStatus = (status: string): string => {
        switch (status) {
            case 'A':
                return 'simcard:bme.status_a';
            case 'D':
                return 'simcard:bme.status_d';
            case 'F':
                return 'simcard:bme.status_f';
            case 'T':
                return 'simcard:bme.status_t';
            case 'P':
                return 'simcard:bme.status_p';
            default:
                return 'simcard:bme.status_unknown';
        }
    };
    let usageParams: Array<ServiceUsageBme> | null = null;
    for (let i = 0; i < params.length; i++) {
        switch (params[i].mainname) {
            case 'status':
                status = { id: params[i].id, value: i18next.t(getStatus(params[i].value)), name: 'simcard:bme.status' } as DisplayParams;
                break;
            case 'service_usage':
                try {
                    usageParams = JSON.parse(params[i].value);
                    if (usageParams) {
                        // inittail
                        let initial: string | number = 0;
                        if (!usageParams[0].totalUnits) {
                            initial = usageParams[0].initialunits;
                        } else {
                            initial = usageParams[0].totalUnits;
                        }
                        const remaining = usageParams[0].remainingunits;
                        const usage = Math.abs(parseInt('' + initial) - parseInt('' + remaining));

                        serviceUsage = {
                            id: params[i].id,
                            value: initial,
                            name: 'simcard:bme.initial',
                        } as DisplayParams;
                        displayParams.push(serviceUsage);

                        serviceUsage = {
                            id: params[i].id,
                            value: usage,
                            name: 'simcard:bme.usage',
                        } as DisplayParams;
                        displayParams.push(serviceUsage);

                        serviceUsage = {
                            id: params[i].id,
                            value: remaining,
                            name: 'simcard:bme.remainingunits',
                        } as DisplayParams;
                        displayParams.push(serviceUsage);
                    }
                } catch (e) {
                    console.log(e);
                }
                break;
            case 'datesubscriptionfeeexpiry':
                datesubscriptionfeeexpiry = {
                    id: params[i].id,
                    value: DateHelper.format(params[i].value),
                    name: 'simcard:bme.datesubscriptionfeeexpiry',
                } as DisplayParams;
                break;
            case 'datesubscriptionfeepaid':
            default:
                break;
        }
    }

    displayParams.push(status);
    displayParams.push(datesubscriptionfeeexpiry);

    return (
        <GridContainer>
            {displayParams.map((item) => {
                if (item) {
                    return (
                        <React.Fragment key={'display_params_' + item.id}>
                            {displayParamName && (
                                <GridItem xs={3}>
                                    <I18n trans="simcard:f.param_name" />
                                </GridItem>
                            )}
                            <GridItem xs={3}>
                                <I18n trans={item.name} />
                            </GridItem>
                            {displayParamName && (
                                <GridItem xs={3}>
                                    <I18n trans="simcard:f.param_value" />
                                </GridItem>
                            )}
                            <GridItem xs={3}>{item.value}</GridItem>
                        </React.Fragment>
                    );
                }
            })}
        </GridContainer>
    );
};
